import { c as _c } from "react/compiler-runtime";
import { LayoutTemplate } from 'lucide-react';
import { useInitiatives } from '@/lib/hooks/useInitiatives';
import { InitiativeCard } from '@/components/initiatives/InitiativeCard';
import { SparkContentSection } from './SparkContentSection';
export function SparkStarters() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isTemplate: true,
      status: "active",
      visibility: "public",
      context: "featured-starters",
      limit: 6
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isLoading
  } = useInitiatives(t0);
  let t1;
  if ($[1] !== data?.pages || $[2] !== isLoading) {
    const initiatives = data?.pages?.flatMap(_temp) ?? [];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        href: "/initiative-starters",
        label: "Browse all Starters"
      };
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = <SparkContentSection icon={LayoutTemplate} iconClassName="text-amber-500" title="Start with a Starter" subtitle="Initiative starters/templates" footerLink={t2} bgClassName="bg-[#f3eee7]" isLoading={isLoading}>{initiatives.map(_temp2)}</SparkContentSection>;
    $[1] = data?.pages;
    $[2] = isLoading;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(initiative) {
  return <InitiativeCard key={initiative.id} initiative={initiative} variant="template" />;
}
function _temp(page) {
  return page.initiatives;
}